"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var constants_1 = require("./constants");
var event_1 = require("./event");
var EventFactory = /** @class */ (function () {
    /**
     * Creates an Event Factory object for a source.
     * @param [options] Options to fix in generated events.
     */
    function EventFactory(_a) {
        var source = _a.source, eventType = _a.eventType;
        this.source = source;
        this.eventType = eventType;
    }
    /**
     * Method to create a new Event with the provided source and data.
     * For creating an event, event type is mandatory so either provide the event
     * type in factory constructor or event factory event data.
     *
     * @param {IEventFactoryEventData} eventData
     * @returns {IEvent} would return undefined if event type is not
     * present else would return a new Event instance.
     */
    EventFactory.prototype.createEvent = function (eventData) {
        var eventType = eventData.eventType
            ? eventData.eventType
            : this.eventType;
        if (!eventType) {
            eventType = constants_1.UNKNOWN_TYPE;
        }
        var source = eventData.source
            ? eventData.source
            : this.source;
        return new event_1.Event(eventData.name, eventType, source, eventData.priority);
    };
    return EventFactory;
}());
exports.EventFactory = EventFactory;
//# sourceMappingURL=event-factory.js.map